import { usePageTitle } from '@calendly/hooks'
import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { ContextualBanner } from '@calendly/ui/components/contextual-banner'
import { FlexLayout } from '@calendly/ui/components/flex-layout'
import { BodyText, HeadingText, TitleText } from '@calendly/ui/components/typography'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { Container } from 'components/organizations/layout'
import { MobileContainer } from 'components/page_elements'

import { AccountSection } from './account'
import { DeletionRequestsSection } from './deletion_requests'
import { InviteeSection } from './invitee'
import { PeriodSection } from './period'
import { reset } from './slice'
import { Divider } from './styles'


export const DataDeletion = () => {
  const dispatch = useDispatch()
  const isMobile = useDeviceType('isPhone')
  const pageTitle = `${I18n.t('publisher.admin.security.tabs.data_deletion')} - ${I18n.t('publisher.admin.security.title')}`

  usePageTitle(pageTitle)

  useEffect(() => () => dispatch(reset()), [dispatch])

  if (isMobile) {
    return (
      <Container>
        <MobileContainer>
          <HeadingText level={3}>{I18n.t('publisher.organization_settings.data_deletion.not_supported')}</HeadingText>
          <BodyText color="muted">{I18n.t('publisher.organization.activity_log.please_adjust')}</BodyText>
        </MobileContainer>
      </Container>
    )
  }

  return (
    <>
      <FlexLayout direction="column" gap={24}>
        <TitleText level={2} size="medium">
          {I18n.t('publisher.organization_settings.data_deletion.header')}
        </TitleText>
        <FlexLayout direction="column" gap={16}>
          <div>
            {I18n.t('publisher.organization_settings.data_deletion.description')}
          </div>
          <ContextualBanner variant="danger" spacingBottom={24}>
            {I18n.t('publisher.organization_settings.data_deletion.alert_description')}
          </ContextualBanner>
          <div>
            {HtmlParser(I18n.t('publisher.organization_settings.data_deletion.cancel_notice'))}
          </div>
        </FlexLayout>
      </FlexLayout>
      <Divider />
      <InviteeSection />
      <Divider />
      <PeriodSection />
      <DeletionRequestsSection />
      <AccountSection />

    </>
  )
}
